import { ExternalAppStatus } from "../../generated/enums"
import { IOmniaShell } from "../../shell"
import { defineDirective } from "../../utils/angular"
import { AppSession } from "../appSession"
import { IAppService } from "../types"

/** @internal */
export class ConnectBasicCtrl {

    static create(): ng.IDirective {
        return defineDirective(ConnectBasicCtrl, "shared/apps/connect/basic.html", {
            "session": "="
        });
    }

    session: AppSession

    user: string
    password: string

    connecting: boolean

    error = false


    static $inject = ["$scope", "OmniaApps", "OmniaShell"];

    constructor(private $scope: ng.IScope, private svc: IAppService, private shell: IOmniaShell) {
    }

    $onInit() {

        this.session.establishNewConnection()

    }

    get ready() {
        return this.session && this.session.connectionId
    }

    get app() {
        return this.session ? this.session.app : null
    }

    canConnect() {
        return this.session && this.session.connectionId && !!this.user && !!this.password
    }

    connect() {

        this.connecting = true

        this.svc
            .validateBasicConnection(this.session.connectionId, this.user, this.password)
            .then(ok => {

                this.session.connected = ok
                this.session.status = ok ? ExternalAppStatus.Ok : undefined
                this.error = !ok

                if (ok) {
                    this.svc.broadcastChange()
                    return this.session.refreshConfig()
                }

            })
            .finally(() => this.connecting = false)

    }

}
